import { GrowthBook, Context } from "@growthbook/growthbook";
import { nanoid } from "nanoid";
import { track } from "./googleAnalytics";
import { getQueryParam } from "./utils";
import {
  Experiment,
  Result,
  FeatureDefinition,
} from "@growthbook/growthbook-react";
import * as Sentry from "@sentry/react";

// when setting up an experiment, we only use numbers as variants
const defaultRule = {
  variations: [0, 1],
  coverage: 1,
};

const features: Record<string, FeatureDefinition<number>> = {};

// add new experiments here
// features["plp-box-sizes"] = {
//   rules: [defaultRule],
// };

features["cart-redesign"] = {
  rules: [defaultRule],
};

const getGrowthBookData = (): GrowthBook<Record<string, any>> => {
  const id = localStorage.getItem("droppsClientId");
  const clientId = id ?? nanoid();
  if (!id) {
    localStorage.setItem("droppsClientId", clientId);
  }

  const initObj: Context = {
    enableDevMode: !!getQueryParam("devmode"),
    attributes: {
      id: clientId,
    },
    features,
    trackingCallback: (experiment: Experiment<any>, result: Result<any>) => {
      track({
        name: "Event",
        eventName: "dl_experiment_viewed",
        params: {
          experiment_id: experiment.key,
          variant_id: result.variationId,
          dropss_client_id: clientId,
        },
      });
    },
  };
  // we run all experiments synchronously, so we don't call loadFeatures().
  // https://docs.growthbook.io/lib/react#custom-integration
  const growthBook = new GrowthBook(initObj);

  return growthBook;
};

export const growthBook = getGrowthBookData();

// make this utility global for a test that is configured in theme.js
window._growthbook = growthBook;

const growthBookTests: Record<string, number> = {};
Sentry.setContext("variants", growthBookTests);
export const getActiveTests = () => {
  if (Object.keys(growthBookTests).length === 0) {
    Object.keys(features).forEach((k) => {
      growthBookTests[k] = growthBook.getFeatureValue(k, 0);
    });
  }
  return growthBookTests;
};
